import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import Start from './pages/start';
import Levels from './pages/levels';
import Splash from './pages/splash';
import Roomload from './pages/roomload';
import Room1 from './pages/room1';
import Dooropen from './pages/dooropen'
import Safepage from './pages/safepage';
import Safepage2 from './pages/safepage2';
import Task3 from './pages/task3';
import Escapedpage from './pages/escapedpage';
import Charchter from './pages/choosecharchter';
import Story from './pages/story';
import Levels2 from './pages/levels2';
import Room2 from './pages/room2';
import Pipes from './pages/pipes';
import Room2task3 from './pages/room2task3';
import Codevidlevel2 from './pages/codevidlevel2';
import Room2task4 from './pages/room2task4';
import Levels3 from './pages/levels3';
import Room3 from './pages/Room3'
import Room4 from './pages/Room4'
import EndlessMode from './pages/EndlessMode';
import Levels4 from './pages/level4';

function Path() {

  return (
    <BrowserRouter>
      <Routes>

                <Route path="/start" element={<Start/>} />
                <Route path="/levels" element={<Levels/>} />
                <Route path="/" element={<Splash/>} />
                <Route path="roomload" element={<Roomload/>} />
                <Route path="/room1" element={<Room1 />} />
                <Route path="/dooropen" element={<Dooropen />} />
                <Route path="/safepage" element={<Safepage />} />
                <Route path="/safepage2" element={<Safepage2 />} />
                <Route path="/task3" element={<Task3 />} />
                <Route path="/escapedpage" element={<Escapedpage/>} />
                <Route path="/Charchter" element={<Charchter/>} />
                <Route path="/Story" element={<Story/>} />
                <Route path="/levels2" element={<Levels2/>} />
                <Route path="/room2" element={<Room2/>} />
                <Route path="/room2task3" element={<Room2task3/>} />
                <Route path="/pipes" element={<Pipes/>} />
                <Route path="/Codevidlevel2" element={<Codevidlevel2/>} />
                 <Route path="/room2task4" element={<Room2task4/>} />
                <Route path="/levels3" element={<Levels3/>} />
                <Route path="/room3" element={<Room3/>} />
                <Route path="/room4" element={<Room4/>} />
                <Route path="/endlessmode" element={<EndlessMode/>} />
                <Route path="/level4" element={<Levels4/>} />
                
            

      </Routes>
    </BrowserRouter>
  );
}

export default Path;